import { TableCell } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import HuntStrategyChancesTable from "../../Order/HuntChances/HuntStrategyChancesTable";
import Modal from "../../../Components/Modal/Modal";
import Button from "../../../Components/Button";
import { OrderStrategy } from "../../../Interfaces/orderInterfaces";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import BrokerOrdersTable from "../../Step/BrokerOrder/BrokerOrdersTable";
import { INLegsTradeTableReport } from "../../../Interfaces/nLegsInterfaces";
import {
  getNLegBrokerOrdersTable,
  getNLegShekarChanceTable,
} from "../../../Requests/nLegsRequests";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: INLegsTradeTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isChancesOpen, setIsChancesOpen] = React.useState(false);
  const [isBrokerOrdersModalOpen, setIsBrokerOrdersModalOpen] =
    React.useState(false);

  function errorHandler(e: any) {
    let error: any;

    if (!e) error = "خطا در ارتباط با سرور";
    if (e.msg) error = e.msg;
    if (e?.response?.data?.value) error = e.response.data.value;
    toast.error(error);
  }

  const btnClickHandler = () => {
    setIsChancesOpen(true);
  };

  return (
    <>
      <TableCell>
        {isBrokerOrdersModalOpen ? (
          <Modal title="سفارشات"
            UI={
              <BrokerOrdersTable
                getData={getNLegBrokerOrdersTable}
                nlegId={row.id}
              />
            }
            onClose={() => setIsBrokerOrdersModalOpen(false)}
          />
        ) : null}
        <Button
          onClick={() => setIsBrokerOrdersModalOpen(true)}
          text="سفارشات"
          variant="contained"
          className="table-btn"
        />
      </TableCell>

      <TableCell>
        {isChancesOpen ? (
          <Modal title="شانس‌ها"
            UI={
              <HuntStrategyChancesTable
                getData={(_, offset, pageSize) =>
                  getNLegShekarChanceTable({ nLegId: row.id }, offset, pageSize)
                }
              />
            }
            onClose={() => setIsChancesOpen(false)}
          />
        ) : null}
        {row.orderStrategy === OrderStrategy.NLeg ? (
          <Button
            onClick={btnClickHandler}
            text="شانس ها"
            variant="contained"
            className="table-btn"
          />
        ) : null}
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<INLegsTradeTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
